<template>
  <div
    id="paymentClass"
    :style="{
      height: country === 'hongkong' ? '40.27083vw' : '44.27083vw',
      padding: country === 'hongkong' ? '80px 0 0px 0' : '80px 0 120px 0',
    }"
  >
    <div class="top">
      <div class="top_box">
        <div>
          <div class="top_title">{{ $t("home_payment_method_title") }}</div>
        </div>
      </div>
      <div class="payment">
        <div class="img-bot">
          <div class="payment-img-top">
            <img
              v-for="(img, idx) in paymentImgTop"
              :key="idx"
              :src="img"
              alt=""
            />
          </div>
          <div v-if="paymentImgBot.length" class="payment-img-bot">
            <img
              v-for="(img, idx) in paymentImgBot"
              :key="idx"
              :src="img"
              alt=""
            />
          </div>
        </div>
        <div
          class="description"
          :style="country === 'hongkong' ? { height: '12.5vw' } : {}"
        >
          <div>
            <div class="description-title">
              <template v-if="country === 'hongkong' && $i18n.locale === 'en'">
                {{ $t("home_payment_method_pricing_1_hk") }}
              </template>
              <template v-else>
                {{ $t("home_payment_method_pricing_title") }}
              </template>
            </div>
            <div
              class="description-content"
              :style="{ marginTop: country === 'hongkong' ? '-1vw' : '1.2vw' }"
            >
              <template v-if="country === 'hongkong' && $i18n.locale === 'en'">
                <br />
                {{ $t("home_payment_method_pricing_2_hk") }}<br />
                {{ $t("home_payment_method_pricing_3_hk") }}<br />
              </template>
              <template v-else>
                {{ $t("home_payment_method_pricing_1") }}<br />
                {{ $t("home_payment_method_pricing_2") }}<br />
                {{ $t("home_payment_method_pricing_3") }}<br />
                {{ $t("home_payment_method_pricing_4") }}<br />
                {{ $t("home_payment_method_pricing_note") }}
              </template>
            </div>
          </div>
          <div v-if="country !== 'hongkong'">
            <div class="description-title2">
              {{ $t("home_payment_method_auth_title") }}
            </div>
            <div class="description-content2">
              {{ $t("home_payment_method_auth_desc") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCountryByDomain } from "@/common/config";
export default {
  name: "PaymentMethod",
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    paymentImgTop() {
      if (this.country === "uk") {
        return [
          require("@/assets/Keeta/4.7.png"),
          require("@/assets/Keeta/4.3.png"),
          require("@/assets/Keeta/4.11.png"),
          require("@/assets/Keeta/4.10.png"),
          require("@/assets/Keeta/4.9.png"),
        ];
      }
      // 默认香港
      return [
        require("@/assets/Keeta/4.7.png"),
        require("@/assets/Keeta/4.3.png"),
        require("@/assets/Keeta/4.11.png"),
        require("@/assets/Keeta/4.10.png"),
        require("@/assets/Keeta/4.9.png"),
      ];
    },
    paymentImgBot() {
      if (this.country === "uk") {
        return [];
      }
      // 默认香港
      return [
        require("@/assets/Keeta/4.8.png"),
        require("@/assets/Keeta2/wx02.png"),
        require("@/assets/Keeta2/zfb02.png"),
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
#paymentClass {
  min-width: $min-width;
  // height: 850px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 120px 0;
  background-color: #ffffff;

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    .top_box {
      width: 100%;
      min-width: 431px;
      .top_title {
        color: #000000;
        font-weight: 900;
        font-size: 1.3rem;
        margin-top: -75px;
        font-family: $title-font;
      }
    }
  }
  .payment {
    width: 1200px;
    height: 560px;
    background-size: 1209px 236px;
    background-repeat: no-repeat;
    background-position: center center;
    min-width: 1170px;
    position: relative;
    .img-bot {
      // height: 70px;
      margin-top: 36px;
      .payment-img-top {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 35px;
        img {
          height: 70px;
          width: auto;
          object-fit: contain;
        }
      }
      .payment-img-bot {
        display: flex;
        margin-left: 100px;
        margin-top: 50px;
        gap: 50px;
        img {
          height: 70px;
          width: auto;
          object-fit: contain;
        }
      }
    }
    .description {
      height: 448px;
      background-color: #fafafa;
      margin-top: 40px;
      border-radius: 20px;
      font-family: $content-font;
      margin-bottom: 120px;
      .description-title {
        color: #111111;
        font-family: Arial;
        font-weight: 700;
        font-size: $font-size-base;
        line-height: normal;
        text-align: left;
        padding: 50px 50px 0px 50px;
        box-sizing: border-box;
      }
      .description-content {
        font-weight: 400;
        font-family: Arial;
        font-size: $font-size-small;
        line-height: 40px;
        text-align: left;
        color: #888888;
        margin: 12px 50px 0 50px;
      }
      .description-title2 {
        color: #111111;
        font-family: Arial;
        font-weight: 700;
        font-size: $font-size-base;
        line-height: normal;
        text-align: left;
        padding: 40px 50px 0px 50px;
        box-sizing: border-box;
      }
      .description-content2 {
        font-weight: 400;
        font-family: Arial;
        font-size: $font-size-small;
        line-height: 40px;
        text-align: left;
        color: #888888;
        margin: 12px 50px 50px 50px;
      }
    }
  }
}
</style>
